module.exports = __webpack_public_path__ + "static/media/user.8616fc93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/user.svg
// module id = 368
// module chunks = 0